import { GetCulpritVehicleCorrectiveImagesFormTabsParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritVehicleCorrectiveImagesFormTabs/getCulpritVehicleCorrectiveImagesFormTabs.type';
import { getCulpritVehicleCorrectiveImagesFormTabsFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritVehicleCorrectiveImagesFormTabs/getCulpritVehicleCorrectiveImagesFormTabsFunction';
import { queryOptions } from '@tanstack/react-query';

const getCulpritVehicleCorrectiveImagesFormTabsOptions = (
  params: GetCulpritVehicleCorrectiveImagesFormTabsParamsType,
) =>
  queryOptions({
    queryKey: ['GET_CULPRIT_VEHICLE_CORRECTIVE_IMAGE_FORM_TABS', params],
    queryFn: () => getCulpritVehicleCorrectiveImagesFormTabsFunction(params),
  });
export default getCulpritVehicleCorrectiveImagesFormTabsOptions;
